import { HelpCircle } from 'lucide-react';
import { Popover, PopoverContent, PopoverTrigger } from '@/components/ui/popover';
import { cn } from '@/lib/utils';
import { GUIDE_TOPICS, type GuideTopicId } from '../content/topics';
import { GuideTopicBody } from './GuideTopicBody';

interface FieldHelpProps {
  topicId: GuideTopicId;
  className?: string;
}

/**
 * On-demand help for one field. Deliberately independent of the guideStore's
 * `enabled` flag: what the experienced manager turns off is the interruption,
 * not the ability to look something up.
 */
export function FieldHelp({ topicId, className }: FieldHelpProps) {
  const topic = GUIDE_TOPICS[topicId];

  return (
    <Popover>
      <PopoverTrigger asChild>
        <button
          type="button"
          aria-label={`Ayuda sobre ${topic.title}`}
          className={cn(
            'inline-flex text-muted-foreground transition-colors hover:text-gray-700',
            className,
          )}
        >
          <HelpCircle className="h-4 w-4" />
        </button>
      </PopoverTrigger>
      <PopoverContent className="w-80" side="top">
        <GuideTopicBody topic={topic} />
      </PopoverContent>
    </Popover>
  );
}
